// Entry point for the editorial redesign (layouts/site).
// Deliberately lean: no jQuery or carousel, only the Stimulus controllers these pages use.
import { application } from "./controllers/application";

import CodeBlockController from "./controllers/code_block_controller";
import PostFilterController from "./controllers/post_filter_controller";

application.register("code-block", CodeBlockController);
application.register("post-filter", PostFilterController);
